export const API_BASE_URL = // 'http://localhost:5001/'
  process.env.REACT_APP_API_URL || 'https://api-dev.driversguild.net'

export const QUERY_CLIENT_DEFAULT_OPTIONS = {
  queries: {
    retry: false,
    referchOnWindowFocus: false,
  },
}
